import { GlobalHelper } from "../../indexImports"
import { Entity } from "../helpers/Entity"
import { ASSIGNMENT_KEY_REQUEST_A_QUOTE } from "./AssignmentRuleKeys"

export type AssignmentRuleAttributesDto = {
    userIds: string[]
    locationId: string
    assignmentStrategy: string
    assignmentKey: string
    metadata: object
    accountId: string
    notifyAll: boolean
}

export type AssignmentRuleDto = {
    id: string
    type: string
    attributes: AssignmentRuleAttributesDto
}

export default class AssignmentRule implements Entity {
    private dto: AssignmentRuleDto

    constructor(dto: AssignmentRuleDto) {
        this.dto = dto
    }

    isLoaded(): boolean {
        return this.dto.id != "" && this.dto.type == "assignment-rules"
    }

    getId(): string {
        return this.dto.id
    }

    getUserIds(): string[] {
        return this.dto.attributes.userIds
    }

    getAssignmentKey(): string {
        return this.dto.attributes.assignmentKey
    }

    isEnabled(): boolean {
        switch (this.getAssignmentKey()) {
        case ASSIGNMENT_KEY_REQUEST_A_QUOTE: return GlobalHelper.hasIntegrationSupportingExternalQuoteRequest()
        default: return true
        }
    }

    getNotifyAll(): boolean { 
        return this.dto.attributes.notifyAll
    }
    
}




// WEBPACK FOOTER //
// ./src/state/assignment-rule/AssignmentRule.ts